module.exports = __webpack_public_path__ + "img/skull_narrow_bj.6c470203.png";